import { CampaignActivitiesState } from "./campaignActivities.types";

export const initialState: CampaignActivitiesState = {
  data: [],
  loading: false,
  error: null,
};